import axios from 'axios';
import { decryptData } from './index';

const isSGRegion =
	window.location.hostname.replace('www.', '') ===
	process.env.REACT_APP_SG_DOMAIN;

const axiosClient = axios.create({
	baseURL: process.env.REACT_APP_API_DOMAIN_URL,
	headers: {
		'Content-Type': 'application/json',
		// 'x-version': '~4',
		'x-project-id': isSGRegion
			? process.env.REACT_APP_PROJECT_ID_SG
			: process.env.REACT_APP_PROJECT_ID_MY,
		'x-company-id': isSGRegion
			? process.env.REACT_APP_COMPANY_ID_SG
			: process.env.REACT_APP_COMPANY_ID_MY,
	},
});

axiosClient.interceptors.request.use(
	async (config) => {
		let token = localStorage.getItem('HALEON-REWARDS_USER_TOKEN');

		// RETRIVE RESPECTIVE TOKENS FOR EACH USER TYPE
		if (config.url?.split('/')[1] === 'dsr') {
			token = localStorage.getItem('dsr-token');
		} else if (config.url?.split('/')[1] === 'retailer') {
			token = localStorage.getItem('retailer-token');
		}

		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}

		return config;
	},
	(error) => {
		console.log('error', error);
		return Promise.reject(error);
	},
);

axiosClient.interceptors.response.use(
	async (response) => {
		let token = localStorage.getItem('HALEON-REWARDS_USER_TOKEN');
		if (response.data && response.data.encrypted) {
			const res = await decryptData(response.data, token || '');

			return { ...response, data: res };
		}

		return response;
	},
	(error) => {
		if (
			error?.response.data.message === 'Token Expired' &&
			error?.response.data.statusCode === 403
		) {
			localStorage.clear();
			window.location.reload();
		}

		return Promise.reject(error);
	},
);

export default axiosClient;
